import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Bootstrap_Custom.css";
import "./Style.css";
import "./admin.css";
import "./responsive.css";
import { useEffect, Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import store from "./store";
import { initGA } from "./analytics";
import PageViewTracker from "./PageViewTracker.js";
import ProtectedRoute from "./component/Route/ProtectedRoute";
import PrivateRoute from "./component/Route/PrivateRoute";
import React from "react";
import Loader from "./component/layout/Loader/Loader.js";
import Header from "./component/layout/Header/Header.js";
import { useSelector } from "react-redux";
import ReactGA from 'react-ga';

// Lazy load components for better code splitting
// Core components - load eagerly for better UX
const Home = lazy(() => import("./component/Home/Home"));
const Category = lazy(() => import("./component/Category/Category.js"));
const SingleProduct = lazy(() => import("./component/SingleProduct/SingleProduct.js"));

// User components
const LoginSignUp = lazy(() => import("./component/User/LoginSignUp.js"));
const ForgotPassword = lazy(() => import("./component/User/ForgotPassword.js"));
const UserAccount = lazy(() => import("./component/Account/UserAccount.js"));

// Cart components
const Cart = lazy(() => import("./component/Cart/Cart.js"));
const BuyNow = lazy(() => import("./component/Cart/BuyNow.js"));
const Wishlist = lazy(() => import("./component/Cart/Wishlist.js"));
const Checkout = lazy(() => import("./component/Cart/Checkout.js"));
const Success = lazy(() => import("./component/Cart/Success.js"));
const Cancel = lazy(() => import("./component/Cart/Cancel.js"));

// Order components
const OrderDetails = lazy(() => import("./component/Order/OrderDetails.js"));
const OrderConfirmation = lazy(() => import("./component/Order/OrderConfirmation.js"));

// Product components
const Search = lazy(() => import("./component/Product/Search"));
const CustomSize = lazy(() => import("./component/SingleProduct/CustomSize.js"));

// Static pages
const Contact = lazy(() => import("./component/layout/Contact/Contact"));
const About = lazy(() => import("./component/layout/About/About.js"));
const NotFound = lazy(() => import("./component/layout/Not Found/NotFound"));
const Return = lazy(() => import("./component/OtherPages/Return.js"));
const Shipping = lazy(() => import("./component/OtherPages/Shipping.js"));
const PrivacyPolicy = lazy(() => import("./component/OtherPages/PrivacyPolicy.js"));
const TermsOfService = lazy(() => import("./component/OtherPages/TermsOfService.js"));
const FAQ = lazy(() => import("./component/OtherPages/FAQ.js"));

// Admin components - grouped for better code splitting
const Dashboard = lazy(() => import("./component/Admin/Dashboard.js"));
const Login = lazy(() => import("./component/Admin/login.js"));
const ForgotPass = lazy(() => import("./component/Admin/forgotPass.js"));

// Admin product management
const AddProduct = lazy(() => import("./component/Admin/addProduct.js"));
const UpdateProduct = lazy(() => import("./component/Admin/updateProduct.js"));
const UpdateInventory = lazy(() => import("./component/Admin/updateInventory.js"));
const AllProduct = lazy(() => import("./component/Admin/allProduct.js"));

// Admin category management
const AddCategory = lazy(() => import("./component/Admin/addCategory.js"));
const AllCategory = lazy(() => import("./component/Admin/allCategory.js"));

// Admin other management
const EditHome = lazy(() => import("./component/Admin/editHome.js"));
const Orders = lazy(() => import("./component/Admin/orders.js"));
const OrdersDetail = lazy(() => import("./component/Admin/orders_details.js"));
const Users = lazy(() => import("./component/Admin/users.js"));
const Testimonials = lazy(() => import("./component/Admin/testimonials.js"));
const DiscountCopouns = lazy(() => import("./component/Admin/discountCopouns.js"));
const Customers = lazy(() => import("./component/Admin/customers.js"));
const AddUser = lazy(() => import("./component/Admin/addUser.js"));
const SizeCustomization = lazy(() => import("./component/Admin/sizeCustomization.js"));

ReactGA.initialize(process.env.GA_TRACKING_ID);

function App(props) {
  useEffect(() => {
    initGA();
  }, []);
  
  const { loading } = useSelector((state) => state.user);
  
  useEffect(() => {
    console.log("props", props);
  }, [props]);
  
  window.addEventListener("contextmenu", (e) => e.preventDefault());

  return (
    <Router>
      <PageViewTracker />
      {loading ? <Loader /> : <></>}
      <Route
        render={({ location }) =>
          ![
            "/loginsignup",
            "/admin",
            "/dashboard",
            "/forgotpassword",
            "/forgotpass",
          ].includes(location.pathname.toLowerCase()) ? (
            !location.pathname.toLowerCase().startsWith("/admin/") ? (
              <Header></Header>
            ) : (
              ""
            )
          ) : (
            ""
          )
        }
      />
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/category/:cat/:id" component={Category} />
          <Route exact path="/category/:cat" component={Category} />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/AddProduct"
            component={AddProduct}
          />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/UpdateProduct"
            component={UpdateProduct}
          />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/updateInventory"
            component={UpdateInventory}
          />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/AddCategory"
            component={AddCategory}
          />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/AllCategory"
            component={AllCategory}
          />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            exact
            path="/Admin/AllProduct"
            component={AllProduct}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Adduser"
            component={AddUser}
          />
          <ProtectedRoute
            isAdmin={true}
            isEmployee={true}
            exact
            path="/Admin/sizeCustomization"
            component={SizeCustomization}
          />
          <ProtectedRoute
            isAdmin={true}
            isEmployee={true}
            exact
            path="/Admin/EditHome"
            component={EditHome}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/Orders"
            component={Orders}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/OrdersDetail"
            component={OrdersDetail}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/Users"
            component={Users}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/testimonials"
            component={Testimonials}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/discountCopouns"
            component={DiscountCopouns}
          />
          <ProtectedRoute
            isAdmin={true}
            exact
            path="/Admin/customers"
            component={Customers}
          />
          <Route
            exact
            path="/singleproduct/:id/p/:pid"
            component={SingleProduct}
          />
          <Route
            exact
            path="/singleproduct/:id/p/:pid/:cid"
            component={SingleProduct}
          />
          <Route exact path="/Admin" component={Login} />
          <Route exact path="/LoginSignUp" component={LoginSignUp} />
          <Route exact path="/ForgotPassword" component={ForgotPassword} />
          <Route exact path="/Cart" component={Cart} />
          <Route exact path="/BuyNow" component={BuyNow} />
          <PrivateRoute
            isUser={true}
            exact
            path="/Wishlist"
            component={Wishlist}
          />
          <PrivateRoute
            isUser={true}
            exact
            path="/Checkout"
            component={Checkout}
          />
          <Route exact path="/Return" component={Return} />
          <Route
            isUser={true}
            exact
            path="/CustomSize/:id"
            component={CustomSize}
          />
          <PrivateRoute
            isUser={true}
            exact
            path="/UserAccount"
            component={UserAccount}
          />
          <PrivateRoute isUser={true} exact path="/Success" component={Success} />
          <PrivateRoute isUser={true} exact path="/Cancel" component={Cancel} />
          <Route exact path="/Shipping" component={Shipping} />
          <Route exact path="/PrivacyPolicy" component={PrivacyPolicy} />
          <Route exact path="/TermsOfService" component={TermsOfService} />
          <Route exact path="/FAQ" component={FAQ} />
          <Route exact path="/ForgotPass" component={ForgotPass} />
          <Route exact path="/search/:query" component={Search} />
          <Route exact path="/contact" component={Contact} />
          <PrivateRoute exact path="/OrderDetails" component={OrderDetails} />
          <Route exact path="/OrderConfirmation" component={OrderConfirmation} />
          <Route exact path="/about" component={About} />
          <ProtectedRoute
            isAdmin={true}
            isEditor={true}
            isEmployee={true}
            exact
            path="/admin/dashboard"
            component={Dashboard}
          />
          <Route exact path="/*" component={Home} />
        </Switch>
      </Suspense>

      {/* <Footer /> */}
    </Router>
  );
}

export default App;
